// import { IconTypes } from 'external-services/icons-service/icons.types';
import { IconTypes } from 'external-services/icons-service/icons.types';
import { ITagIcon } from 'external-components/tag-icon/types';
import { IBookingTag, CustomerTypes } from 'shared-types/index';
import { CustomerMode } from 'shared-types';

export const classPrefix = 'CustomerTab';

export enum CustomerDetailType {
  phone = 'phone',
  firstName = 'firstName',
  lastName = 'lastName',
  email = 'email',
  company = 'company',
  // street = 'street',
  streetAddress = 'streetAddress', // from ICustomer
  suburb = 'suburb',
  postcode = 'postcode',
  birthday = 'birthday', // this property is only for detecting change of customer detail, has no actual property
  birthdayDate = 'birthdayDate',
  birthdayMonth = 'birthdayMonth',
  birthdayYear = 'birthdayYear',
  subscribed = 'subscribed',
  membershipNumber = 'membershipNumber',
  // customerNotes = 'customerNotes',
  notes = 'notes', // from ICustomer
  managerNotes = 'managerNotes',
  customerType = 'customerType',
  phone2 = 'phone2',
}

export enum CustomerConfirmStatus {
  DontNeed = '',
  Seat = 'Seat',
  NewWalkin = 'NewWalkin',
}

export enum CustomerConfirmMsg {
  Seat = 'Confirm & Seat',
  NewWalkin = 'Confirm & Save',
}

export interface ICustomerDetail {
  phone?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  visitCount?: number; //visitCount not in ICustomer
  icon?: IconTypes; //icon not in ICustomer
  //tags: IBookingTag[] in ICustomer
  tags?: ITagIcon[]; // from src/app/bookings/tags/TagIcon/types.d.ts
  // add new types here for 'Show more details' section
  company?: string;
  phone2?: string; // in ICustomer, named phone2
  streetAddress?: string;
  suburb?: string;
  postcode?: string;
  birthday?: string;
  birthdayDate?: number;
  birthdayMonth?: number;
  birthdayYear?: number;
  membershipNumber?: string;

  subscribed?: boolean;
  notes?: string;
  managerNotes?: string;
  customerType?: string;
}
export interface ICustomerTab {
  customer?: ICustomerDetail;
  isDisplayOnly?: boolean;
  isBookingCreator?: boolean;
  handleChange?: (type: CustomerDetailType, value: string, value2?: string) => void;
  handleShowMore?: () => void;
  handleCustomerTouched?: () => void;
  checkboxHandler?: (e: boolean) => void;
  smsEmailMessage?: string;
  handleSelectedCustomer?: (customer: any) => void;
  handleEditCustomerForWalkIn?: () => void;
  handleDoNotSendEmailSms?: (e: boolean) => void;
  smsEnabled?: boolean;
  country?: string;
  mode?: 'full' | 'walkin';
  skipAutoComplete?: boolean;
  isCustomerSelected?: boolean;
  isNewMode?: boolean;
  tags?: IBookingTag[];
  isWhiteTheme?: boolean; // this adds extra whiteness when useReversedColors is true
  useReversedColors?: boolean; // assumes the component is sitting on a dark colour, so all text, borders, etc are white
  classPrefix?: string;
  view?: string;
  setView?: (view: CustomerMode) => void;
  showAlertMsg?: boolean;
  cantSaveMessage?: string;
  handleShowMoreExpand?: (isShowMore: boolean) => void;
  isWalkIn?: boolean;
  disableEmailSmsNotification?: boolean;
  expandedCustomer?: boolean;
  expandCustomerHandler?: () => void;
  showNCFIconButtons?: boolean;
  layout?: string;
  isBookedByViewMode?: boolean;
  isMaxWidthOfDropdown?: boolean;
  showWarning?: boolean;
  isNoWrapperPadding?: boolean;
  customerConfirmStatus?: CustomerConfirmStatus;
  handleEditCustomer?: () => void;
  handleConfirmDefaultCustomer?: () => void;
  isWarningSeatConfirm?: boolean;
  visitCount?: number;
}

export interface ICustomerDetailInput {
  icon?: IconTypes;
  placeholder: string;
  detail: string;
  handleChange: (value: string) => void;
  handleCustomerTouched?: () => void;
  muiIcon?: any;
  customerList?: any[];
  inputOnFocus?: () => void;
  disabled?: boolean;
  themeProps?: any
}

export interface ICustomerDetailDisplay {
  icon?: IconTypes;
  detail: string;
  tailPart?: string;
  muiIcon?: any;
  includeIcons?: boolean;
  label?: string;
  iconStyle?: any
}

export interface ICustomerDetailAutocomplete {
  icon?: IconTypes;
  placeholder: string;
  detail: string;
  handleChange: (value: string) => void;
  muiIcon?: any;
  customerList?: any[];
  handleSelectedCustomer?: (customer: any) => void;
  getOptionLabel?: (option: any) => string;
  renderOption?: (option: any) => string;
  customer?: any;
  loading?: boolean;
  handleCustomerTouched?: () => void;
  disabled?: boolean;
  isMaxWidthOfDropdown?: boolean;
}

export interface ICustomerConfirm {
  firstName: string;
  handleEditCustomer: () => void;
  handleConfirmDefaultCustomer: () => void;
  customerConfirmStatus?: CustomerConfirmStatus;
  isWarningSeatConfirm?: boolean;
}
